import React, { useReducer } from "react";
import { TeamContext } from "../Contexts.js";
import teamReducer from "./TeamReducer.js";

const TeamState = (props) => {
  const initialState = {
    teamMembers: [
      {
        id: 1,
        image_path: "images/ginger-headshot.jpg",
        first_name: "Ginger",
        last_name: "Kratzmeyer",
        headline: "Licensed Massage Therapist",
        description:
          "Ginger, a seasoned Licensed Massage Therapist, is devoted to your well-being and the transformative power of touch. With over 11 years of experience, she has mastered the art of deep-tissue massage, the soothing warmth of hot stone therapy, and the precision of trigger point release. But it’s not just about technique: Ginger’s commitment to exceptional customer service ensures that every client leaves their massage session feeling blissfully relaxed and eager to book their next appointment.",
      },
      {
        id: 2,
        image_path: "images/alex-headshot.jpg",
        first_name: "Alexandra (Alex)",
        last_name: "Romero",
        headline: "Licensed Massage Therapist",
        description:
          "Alex is a skilled and compassionate bilingual massage therapist with over five years of experience helping clients feel their best. Fluent in both English and Spanish, she specializes in a variety of techniques, including Lymphatic Drainage, hot stone therapy, deep tissue massage, and more. Known for her personalized approach, Alex not only provides effective bodywork but also takes the time to educate her clients on wellness practices that support long-term health and healing. Her goal is to create a supportive space where clients can relax, recover, and reconnect with their bodies.",
      },
      {
        id: 3,
        first_name: "Jade",
        last_name: "Rogers",
        headline: "Licensed Massage Therapist",
        description: "Peace and wellness! I’m Jade Rogers, a passionate and intuitive licensed massage therapist dedicated to helping clients heal, relax, and reconnect with their bodies. With over 7 years of hands-on experience in holistic wellness, I specialize in therapeutic techniques that relieve tension, improve mobility, and support overall well-being. My approach blends clinical skill with a calming presence, creating a customized experience for every client. With the incorporation of breath work and bodywork, I create an ambiance of ultimate wellness and relaxation. I believe in the power of touch as a tool for transformation—physically, emotionally, and energetically.",
        image_path: "images/jade-headshot.jpg",
      },
      {
        id: 4,
        first_name: "Dontrell",
        last_name: "Smith",
        headline: "Licensed Massage Therapist",
        description: "Dontrell brings a calm, caring touch to every session. Attentive and adaptive, he adjusts pressure so each area feels both effective and soothing, helping to ease inflammation, improve circulation, and boost your daily energy while reducing muscle fatigue. He takes time to understand each client’s specific areas of discomfort and, through focus and open communication, works with you to find real relief. Whether you’d like to chat or simply enjoy a quiet session, Dontrell creates a comfortable space where you can fully relax. Heated and pregnancy tables are available to ensure every massage fits your needs.",
        image_path: "images/dontrell-headshot.jpg"
      },
      {
        id: 6,
        first_name: "Nicole",
        last_name: "Butler",
        headline: "Licensed Massage Therapist",
        description: "With over 15 years of experience in the wellness industry, Nicole specializes in a wide range of therapeutic massage modalities designed to address complex musculoskeletal concerns and support recovery. Her skill set includes Hot Stone Massage, Corporate Chair Massage, Medical Massage, Deep Tissue Massage, Sports Massage, Stretching, and Lymphatic Drainage.\n\n Nicole is especially passionate about rehabilitative massage and takes a thoughtful, results-driven approach to bodywork. She combines technical precision with a holistic perspective, tailoring each session to your specific needs and recovery goals to help you move better, feel better, and heal more effectively.",
        image_path: "images/nicole-headshot.jpg"
      }
    ],
    filtered: null, // Array of filtered therapists
    current: null,
  };

  const [state, dispatch] = useReducer(teamReducer, initialState);

  // Load Team Members
  const loadTeamMembers = async () => {
    await dispatch({
      type: "TEAM_MEMBERS_LOADED",
      payload: initialState.teamMembers,
    });
  };

  return (
    <TeamContext.Provider
      value={{
        teamMembers: state.teamMembers,
        current: state.current,
        filtered: state.filtered,
        loadTeamMembers,
      }}
    >
      {props.children}
    </TeamContext.Provider>
  );
};

export default TeamState;
